import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';

@Component({
    selector: 'dojo-manage-user-header',
    templateUrl: './dojo-manage-user-header.component.html'
})
export class DojoManageUserHeaderComponent implements OnInit, AfterViewInit {
    clientName: string;
    userId: string;
    subscriberId: string;
    loginId: string;

    constructor(private translationService: PershingTranslationService, private paramService: NxiWidgetParamsService ) {
    }

    ngOnInit( ) {
        this.getWidgetResponse();
    }

    getWidgetResponse(): any {
      this.paramService.getWidgetParam('/portfolio/getAdvisorVO').subscribe(
      resp => {
        console.log('response', resp);
        this.clientName  = resp.clientName;
        this.userId = resp.userId;
        this. subscriberId = resp.subscriberId;
        this.loginId = resp.loginId;
      },
     error => {
        console.log('error', error);
        return error;
      }
    );
  }
    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
    }

}
